import { get, post, put, remove, removeMultiple } from "../../utils/httpClient";

const taskService = () => {
  const prefixApi = "duedates/tasks";

  const getTasks = async () => {
    return await get(`/${prefixApi}`);
  };

  const getTask = async (id) => {
    return await get(`/${prefixApi}/${id}`);
  };

  const getAllTaskNames = async (boardId) => {
    return await get(`/${prefixApi}/names`, { boardId: boardId });
  };

  const getTaskByDateRange = async (boardId, from, to) => {
    return await get(`/${prefixApi}/calendar`, {
      from: from,
      to: to,
      boardId: boardId,
    });
  };

  const getTasksToRollover = async (json) => {
    //This endpoint receives a List of clients so it cannot be a get.
    return await post(`/${prefixApi}/torollover`, json);
  };

  const getTaskExport = async (boardId) => {
    return await get(
      `/${prefixApi}/export`,
      { boardId: boardId },
      {
        responseType: "blob",
      }
    );
  };

  const getTasksYears = async (boardId, taskTypeId) => {
    return await get(`/${prefixApi}/years`, {
      boardId: boardId,
      taskTypeId: taskTypeId,
    });
  };

  const createTask = async (json) => {
    return await post(`/${prefixApi}`, json);
  };

  const updateTask = async (json) => {
    return await put(`/${prefixApi}`, json);
  };

  const updateExtendedDate = async (json) => {
    return await put(`/${prefixApi}/extendeddate`, json);
  };

  const updateTaskCollaborators = async (json) => {
    return await put(`/${prefixApi}/collaborators`, json);
  };

  const addTaskCollaborator = async (json) => {
    return await post(`/${prefixApi}/collaborators`, json);
  };

  const bulkUpdateTasks = async (params, json) => {
    return await put(`/${prefixApi}/bulk`, json, params);
  };

  const deleteTask = async (id) => {
    return await remove(`/${prefixApi}/${id}`);
  };

  const deleteMultipleTasks = async (json) => {
    return await removeMultiple(`/${prefixApi}`, json);
  };

  const markTasksAsCompleted = async (json) => {
    return await post(`/${prefixApi}/completed`, json);
  };

  const calculateDueDate = async (json) => {
    return await post(`/${prefixApi}/duedate/calculate`, json);
  };

  const calculatePeriodEnd = async (json) => {
    return await post(`/${prefixApi}/periodend/calculate`, json);
  };

  const rolloverTasks = async (json) => {
    return await post(`/${prefixApi}/rollover`, json);
  };

  return {
    getTask,
    getTasks,
    getTaskByDay: getTaskByDateRange,
    getTasksToRollover,
    getTasksYears,
    createTask,
    updateTask,
    updateExtendedDate,
    updateTaskCollaborators,
    bulkUpdateTasks,
    deleteTask,
    deleteMultipleTasks,
    markTasksAsCompleted,
    calculateDueDate,
    rolloverTasks,
    getAllTaskNames,
    calculatePeriodEnd,
    addTaskCollaborator,
    getTaskExport,
  };
};

export default taskService;
